import types from "resources/types";
import { createResourceListQuery } from "queries";

export const previousEmploymentsQuery = (config = {}) =>
  createResourceListQuery(types.PREVIOUS_EMPLOYMENTS, {
    url: "/api/v2/previous_employments/?limit=999",
    ...config,
  });
